import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import theme from "assets/theme";
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import HeaderContainer from "styles/components/headerContainer";
import TAUSAMap from "components/TAUSAMap";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import useMediaQueries from "utils/mediaQueries.utils";

const StateMap = ({ ...props }) => {
  const { title, mapConfig, description, stateLinks } = props;
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState(window.innerWidth - "2rem");

  const { isLg, isMd } = useMediaQueries();

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth - "2rem");
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowSize]);

  const stateCustomConfig = Object.entries(mapConfig).reduce((acc, [state, config]) => {
    acc[state] = {
      ...config,
      clickHandler: () => navigate(config.route),
    };
    return acc;
  }, {});

  return (
    <StyledSectionContainer sx={{ textAlign: "center" }}>
      <HeaderContainer
        title={title}
        textColor={theme.palette.primary.main}
        component="h2"
        variant="h1"
        highlightText={props.highlightText}
        highlightColor={theme.palette.accent.main}
      />
      <MKBox>
        <MKTypography variant="body1" element="p" sx={{ textAlign: "center" }}>
          {description}
        </MKTypography>
      </MKBox>
      <TAUSAMap stateCustomConfig={stateCustomConfig} height={isLg ? null : isMd ? 500 : 400} />
      {stateLinks && stateLinks.length > 0 && (
        <MKBox sx={{ display: "flex", justifyContent: "center", gap: 3, flexWrap: "wrap", mt: 2 }}>
          {stateLinks.map((link, index) => (
            <MKTypography
              key={index}
              component={Link}
              to={link.route}
              variant="body1"
              sx={{
                color: theme.palette.accent.main,
                textDecoration: "underline",
                "&:hover": { color: theme.palette.primary.main },
              }}
            >
              {link.text}
            </MKTypography>
          ))}
        </MKBox>
      )}
    </StyledSectionContainer>
  );
};

export default StateMap;
